/**
 * LES ROUTES DU MODULE SOUS LA FICHE D'UNE SOURCE (LOT F3). La fiche source
 * n'est pas générée : `core/router/source.routes.ts` les ajoute à la main.
 */
import type { RouteRecordRaw } from "vue-router"
import { enfantsSurveillance } from "./utils/routesEquipement"

export const sourceShellChildren: RouteRecordRaw[] =
    enfantsSurveillance("source")
